export const orgNoRegex = new RegExp(/^\d{9}$/)
export const emailRegex = new RegExp(/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])/)
export const phoneRegex = new RegExp(/^[\d\s\-+()]{8,}$/)
export const validAccountNoRegex = new RegExp( /^(?!0\d{3}|1500|2400)\d{4}$/)
export const accountNameRegex = new RegExp(/^.+$/)
